var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07432 0C3.6317 0 0 3.63182 0 8.07428C0 12.5169 3.632 16.1486 8.07432 16.1486C9.78418 16.1486 11.3742 15.6168 12.6828 14.7014L16.5641 18.5828C17.1206 19.1391 18.0263 19.1391 18.5826 18.5828C19.1391 18.0263 19.1391 17.128 18.5826 16.5715L14.6939 12.6828C15.6087 11.3742 16.1485 9.78376 16.1485 8.07437C16.1485 3.63177 12.5165 8.47762e-05 8.07415 8.47762e-05L8.07432 0ZM8.07432 2.84983C10.9767 2.84983 13.299 5.17203 13.299 8.0745C13.299 10.9769 10.9766 13.2992 8.07432 13.2992C5.17192 13.2992 2.84963 10.9768 2.84963 8.0745C2.84963 5.17211 5.17201 2.84983 8.07432 2.84983Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.63d01c1ffbf484654a493175549a7d1d.svg";
export { ForwardRef as ReactComponent };